import { chakra, EloIcon, RadioGroup } from '@plurall/elo-v3';

import {
  FeedbackFloaterActionsRecipe,
  FeedbackFloaterCounterRecipe,
  FeedbackFloaterFieldRecipe,
  FeedbackFloaterFormRecipe,
  FeedbackFloaterHelperRecipe,
  FeedbackFloaterLabelRecipe,
  FeedbackFloaterLoadingRecipe,
  FeedbackFloaterPanelRecipe,
  FeedbackFloaterRootRecipe,
  FeedbackFloaterScoreIconRecipe,
  FeedbackFloaterScoreLabelRecipe,
  FeedbackFloaterScoreRecipe,
  FeedbackFloaterScoresRecipe,
  FeedbackFloaterSuccessRecipe,
  FeedbackFloaterTextRecipe,
  FeedbackFloaterTextareaRecipe,
  FeedbackFloaterTitleRecipe,
  FeedbackFloaterTriggerRecipe,
} from './FeedbackFloater.recipe';

export const FeedbackFloaterRootFactory = chakra('aside', FeedbackFloaterRootRecipe);
export const FeedbackFloaterTriggerFactory = chakra('button', FeedbackFloaterTriggerRecipe);
export const FeedbackFloaterPanelFactory = chakra('section', FeedbackFloaterPanelRecipe);
export const FeedbackFloaterTitleFactory = chakra('h2', FeedbackFloaterTitleRecipe);
export const FeedbackFloaterFormFactory = chakra('form', FeedbackFloaterFormRecipe);
export const FeedbackFloaterScoresFactory = chakra(RadioGroup.Root, FeedbackFloaterScoresRecipe);
export const FeedbackFloaterScoreFactory = chakra(RadioGroup.Item, FeedbackFloaterScoreRecipe);
export const FeedbackFloaterScoreIconFactory = chakra(EloIcon, FeedbackFloaterScoreIconRecipe);
export const FeedbackFloaterScoreLabelFactory = chakra('span', FeedbackFloaterScoreLabelRecipe);
export const FeedbackFloaterFieldFactory = chakra('div', FeedbackFloaterFieldRecipe);
export const FeedbackFloaterLabelFactory = chakra('label', FeedbackFloaterLabelRecipe);
export const FeedbackFloaterTextareaFactory = chakra('textarea', FeedbackFloaterTextareaRecipe);
export const FeedbackFloaterHelperFactory = chakra('p', FeedbackFloaterHelperRecipe);
export const FeedbackFloaterCounterFactory = chakra('p', FeedbackFloaterCounterRecipe);
export const FeedbackFloaterActionsFactory = chakra('div', FeedbackFloaterActionsRecipe);
export const FeedbackFloaterLoadingFactory = chakra('span', FeedbackFloaterLoadingRecipe);
export const FeedbackFloaterSuccessFactory = chakra('div', FeedbackFloaterSuccessRecipe);
export const FeedbackFloaterTextFactory = chakra('p', FeedbackFloaterTextRecipe);
